<template>
  <div class="page d-flex flex-column align-items-center justify-content-center">
    <div class="card shadow-lg rounded-3 py-4 px-3" style="border:none">
      <div class="card-body text-center">
        <h2 class="mb-3 text-dark text-uppercase" style="font-weight:700">Subscription Validation</h2>
        <div v-if="loading">
          <p class="text-muted mb-4">Please wait while we validate your store subscription…</p>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-if="errorMessage && !loading" class="mt-3 w-100" role="alert">
          <div class="alert alert-danger" style="white-space: pre-wrap; text-align: left;">{{ errorMessage }}</div>
          <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-outline-secondary" @click="retryValidation">Retry</button>
          </div>
        </div>
        <div v-if="isExpired && !loading" class="mt-4 d-flex flex-column align-items-center">
          <p class="mb-3">Your subscription is expired. Please select another store or make payment.</p>
          <div class="d-flex gap-2">
            <button type="button" class="btn btn-outline-primary" @click="goToStoreSelect">Select Store</button>
            <button type="button" class="btn btn-primary" @click="goToSubscriptionPage">
              Make Payment
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ValidationView',
  data() {
    return {
      isExpired: false,
      errorMessage: '',
      loading: true,
      invoice: null,
    }
  },
  async mounted() {
    await this.validateSubscription();
  },
  methods: {
    getExactErrorMessage(err) {
      try {
        if (!err) return 'Unknown error occurred';
        // Axios error with response
        if (err.response) {
          const { status, statusText, data } = err.response;
          if (data) {
            if (typeof data === 'string') return data;
            if (typeof data === 'object') {
              if (data.message) return data.message;
              if (data.error) return data.error;
              if (data.detail) return data.detail;
            }
          }
          return `HTTP ${status}${statusText ? ' - ' + statusText : ''}`;
        }
        // Timeout or network errors
        if (err.code === 'ECONNABORTED') return 'Request timed out. Please check your connection and try again.';
        if (err.message) return err.message;
        return String(err);
      } catch (e) {
        return 'An unexpected error occurred';
      }
    },
    async validateSubscription() {
      try {
        this.errorMessage = '';
        this.loading = true;
        this.$utils && this.$utils.showLoading && this.$utils.showLoading();
        const isExpired = await this.$store.dispatch('checkExpiry');
        if (isExpired === true) {
          this.isExpired = true;
          this.loading = false;
          this.$utils && this.$utils.hideLoading && this.$utils.hideLoading();
          return;
        }
        // Not expired → go to POS login
        this.loading = false;
        this.$utils && this.$utils.hideLoading && this.$utils.hideLoading();
        this.$router.replace({ name: 'poslogin' });
      } catch (e) {
        this.$utils && this.$utils.hideLoading && this.$utils.hideLoading();
        this.errorMessage = this.getExactErrorMessage(e) || 'Unable to validate subscription. Please try again.';
        this.loading = false;
      }
    },
    retryValidation() {
      this.validateSubscription();
    },
    goToStoreSelect() {
      this.$router.replace({ name: 'setup' });
    },
    goToSubscriptionPage() {
      if (!this.invoice) {
        this.$utils.showLoading();
        return this.$store.dispatch('getDueInvoices')
          .then(res => {
            this.invoice = res;
            if (res) {
              window.open('https://subscription.chrilantech.com/?reference=' + this.invoice.id);
            }
          })
          .catch(err => {
            this.errorMessage = this.getExactErrorMessage(err);
          })
          .finally(() => this.$utils.hideLoading());
      }
    }
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: rgb(64, 67, 74);
  background: -moz-linear-gradient(180deg, rgba(64, 67, 74, 1) 14%, rgba(255, 255, 255, 1) 14%);
  background: -webkit-linear-gradient(180deg, rgba(64, 67, 74, 1) 14%, rgba(255, 255, 255, 1) 14%);
  background: linear-gradient(180deg, rgba(64, 67, 74, 1) 14%, rgba(255, 255, 255, 1) 14%);
}
</style>


